export default __webpack_public_path__ + "static/media/nicotina.d2386933.svg";